// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.final{
    text-align: center;
}
.final__first{
    padding-top: 1.8em;
    padding-bottom: 2.15625em;
}
.final__rating{
    display: flex;
    flex-direction: column;    
    align-items: center;
    background: #5036E6;
    border-radius: 1.5em;
    padding: 1.75em 1em 1.9375em;
    margin-bottom: 1.5em;
}
.final__ratingLogo{
    margin-bottom: 0.4em;
    width: 5.9375em;
    height: auto;
}
.final__image{
    width: auto;
    height: 11em;
    margin-bottom: 0.4em;
}
.final__resultTitle{
    font-weight: 700;
    font-size: 1.875em;
    line-height: 1;
    letter-spacing: 0.01em;
    margin-bottom: 0.5rem;
}
.final__resultText{
    font-size: 0.875em;
    line-height: 1.142;
    margin: 0 auto;
    max-width: 17.8em;
}
.final__socialTitle{
    font-size: 0.875em;
    line-height: 1.142;    
    margin-bottom: 0.9em;
    color: #FBFBFB;
}
.final__socialWrapper{
    display: flex;
    justify-content: center;
    align-items: center;
}
.final__socialLink{
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 0.21875em;
    padding: 0;
    border: none;
    background: transparent;
}
.final__socialLink svg{
    width: 2.3125em;
    height: auto;
}
.final__second{
    background: #232325;
    border-radius: 1.5em;
    padding: 2.35em 0 2.1em;
    margin-bottom: 1.8em;
}
.final__secondTitle{
    font-weight: 700;
    font-size: 1.875em;
    line-height: 1;
    letter-spacing: 0.01em;
    margin-bottom: 0.75rem;
}
.final__secondText{
    font-size: 0.875em;
    line-height: 1.286;
    margin-bottom: 2.1em;
}
.final__secondScroll{
    overflow: auto;
    padding-bottom: 0.8em;
    width: 100vw;
}
.final__secondWrapper{
    display: flex;
    align-items: flex-start;
    padding-left: 0.6em;
}
.final__people{
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-shrink: 0;
    width: 5.82em;
}
.final__people:last-child{
    padding-right: 0.6em;
    width: 6.42em;
}
.final__peopleAva{
    width: 3.75em;
    height: 3.75em;
    border-radius: 100%;
    margin-bottom: 0.5em;
}
.final__peopleName{
    color: #FFEAEA;
    font-size: 0.875em;
    line-height: 1.286;    
}
.final__peopleName svg{
    display: none;
    width: 0.75rem;
    height: auto;
}
.final__secondBottomText{
    display: none;
}
.final__third{
    padding-bottom: 2em;
}
.final__thirdIco{
    display: inline-block;
    width: 2.5625em;
    height: auto;
    margin-bottom: 0.9em;
}
.final__thirdText{
    margin: 0 auto;
    max-width: 19em;
    font-size: 0.875em;
    line-height: 1.286;  
    margin-bottom: 1.8rem;  
}
.final__thirdBtns{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.btn__final{
    margin-bottom: 1.1em;
    width: 9.0625em;
}
.btn__restart{
    width: 9.875em;
    background: #454545;
}
@media(min-width: 100vh){
    .final{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        width: 100%;
        position: relative;
        max-width: 74em;
        margin: 0 auto;
        left: 1.85em;
        padding: 5.7em 0.5em 0;
    }
    .final__first{
        padding: 0;
        width: 21.125em;
    }
    .final__rating{
        border-radius: 2.8125em;
        padding: 0 2.125em 1em;
        min-height: 24.8125em;
        margin-bottom: 1.1em;
    }
    .final__ratingLogo{
        display: none;
    }
    .final__image{
        height: 12.8125em;
        margin: -1.2em 0 0.5em;
    }
    .final__resultTitle{
        font-size: 2.1875em;
        min-height: 4.375rem;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 1rem;
    }
    .final__resultText{
        font-size: 0.9375em;
        line-height: 1.13333;
    }
    .final__socialTitle{
        font-size: 1em;
        margin-bottom: 1em;
    }
    .final__socialLink{
        transition: 0.3s transform;
    }
    .final__socialLink:hover{
        transform: scale(1.05);
    }
    .final__second{
        width: 22em;
        border-radius: 0;
        background: transparent;
        margin: 0 2.3em 0 0;
        padding: 2.35em 0 0em;
    }
    .final__secondTitle,
    .final__secondText{
        display: none;
    }
    .final__secondScroll{
        width: 100%;
        overflow: inherit;
    }
    .final__secondWrapper{
        padding: 0;
        flex-wrap: wrap;
        justify-content: center;
    }
    .final__people,
    .final__people:last-child{
        padding: 0;
        width: 7.2em;
        margin-bottom: 1em;
        transition: 0.3s transform;
    }
    .final__people:hover{
        transform: scale(1.05);
    }
    .final__peopleAva{
        width: 4.1875em;
        height: 4.1875em;
        margin-bottom: 0.7em;
    }
    .final__peopleName{
        font-weight: 500;
        font-size: 0.75em;
        color: #fff;
        max-width: 8em; 
    }
    .final__peopleName svg{
        display: inline-block;
        position: relative;
        top: 0.1rem;
    }
    .final__peopleName span{
        white-space: nowrap;
    }
    .natSpan{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .natSpan svg{
        top: -0.1em;
        flex-shrink: 0;
        margin-left: 0.2em;
    }
    .final__secondBottomText{
        margin: 1em auto 0; 
        line-height: 1.1875;
        color: #FBFBFB;
        display: block;
    }
    .final__third{
        width: 21.3125em;
        text-align: left;
        padding: 0;
    }
    .final__thirdIco{
        margin: 2.75em 0 1.35em -0.25em;
    }
    .final__thirdText{
        max-width: 100%;
        font-size: 1.5em;
        line-height: 1.41666;
        margin-bottom: 1.65rem;
    }
    .final__thirdBtns{
        width: 100%;
        flex-direction: row;
        align-items: center;
    }
    .btn__final{
        width: 6.125em;
        margin: 0 0.5625em 0 0;
    }
    .btn__restart{
        width: 10.125em;
    }
    .btn__restart:hover{
        background: #FF5317;
    }
}
@media(min-width: 100vh) and (max-width: 150vh){
    .final{
        left: 0;
        font-size: 1.4vw;
    }
    .final__second{
        margin: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/routes/Final/final.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,oBAAoB;IACpB,4BAA4B;IAC5B,oBAAoB;AACxB;AACA;IACI,oBAAoB;IACpB,eAAe;IACf,YAAY;AAChB;AACA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,qBAAqB;AACzB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,cAAc;AAClB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,YAAY;AAChB;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,cAAc;IACd,qBAAqB;IACrB,YAAY;AAChB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;IACd,aAAa;AACjB;AACA;IACI,oBAAoB;IACpB,aAAa;AACjB;AACA;IACI,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,oBAAoB;AACxB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,cAAc;IACd,YAAY;AAChB;AACA;IACI,aAAa;AACjB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,YAAY;IACZ,oBAAoB;AACxB;AACA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,oBAAoB;IACpB,eAAe;AACnB;AACA;IACI,cAAc;IACd,mBAAmB;AACvB;AACA;IACI;QACI,aAAa;QACb,uBAAuB;QACvB,8BAA8B;QAC9B,WAAW;QACX,kBAAkB;QAClB,eAAe;QACf,cAAc;QACd,YAAY;QACZ,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,eAAe;IACnB;IACA;QACI,uBAAuB;QACvB,sBAAsB;QACtB,qBAAqB;QACrB,oBAAoB;IACxB;IACA;QACI,aAAa;IACjB;IACA;QACI,iBAAiB;QACjB,sBAAsB;IAC1B;IACA;QACI,mBAAmB;QACnB,oBAAoB;QACpB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,mBAAmB;IACvB;IACA;QACI,mBAAmB;QACnB,oBAAoB;IACxB;IACA;QACI,cAAc;QACd,kBAAkB;IACtB;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,uBAAuB;QACvB,mBAAmB;QACnB,qBAAqB;IACzB;IACA;;QAEI,aAAa;IACjB;IACA;QACI,WAAW;QACX,iBAAiB;IACrB;IACA;QACI,UAAU;QACV,eAAe;QACf,uBAAuB;IAC3B;IACA;;QAEI,UAAU;QACV,YAAY;QACZ,kBAAkB;QAClB,0BAA0B;IAC9B;IACA;QACI,sBAAsB;IAC1B;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,oBAAoB;IACxB;IACA;QACI,gBAAgB;QAChB,iBAAiB;QACjB,WAAW;QACX,cAAc;IAClB;IACA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,WAAW;IACf;IACA;QACI,mBAAmB;IACvB;IACA;QACI,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,cAAc;QACd,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,mBAAmB;QACnB,cAAc;QACd,cAAc;IAClB;IACA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,UAAU;IACd;IACA;QACI,+BAA+B;IACnC;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,oBAAoB;QACpB,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,mBAAmB;QACnB,mBAAmB;IACvB;IACA;QACI,cAAc;QACd,sBAAsB;IAC1B;IACA;QACI,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,OAAO;QACP,gBAAgB;IACpB;IACA;QACI,SAAS;IACb;AACJ","sourcesContent":[".final{\n    text-align: center;\n}\n.final__first{\n    padding-top: 1.8em;\n    padding-bottom: 2.15625em;\n}\n.final__rating{\n    display: flex;\n    flex-direction: column;    \n    align-items: center;\n    background: #5036E6;\n    border-radius: 1.5em;\n    padding: 1.75em 1em 1.9375em;\n    margin-bottom: 1.5em;\n}\n.final__ratingLogo{\n    margin-bottom: 0.4em;\n    width: 5.9375em;\n    height: auto;\n}\n.final__image{\n    width: auto;\n    height: 11em;\n    margin-bottom: 0.4em;\n}\n.final__resultTitle{\n    font-weight: 700;\n    font-size: 1.875em;\n    line-height: 1;\n    letter-spacing: 0.01em;\n    margin-bottom: 0.5rem;\n}\n.final__resultText{\n    font-size: 0.875em;\n    line-height: 1.142;\n    margin: 0 auto;\n    max-width: 17.8em;\n}\n.final__socialTitle{\n    font-size: 0.875em;\n    line-height: 1.142;    \n    margin-bottom: 0.9em;\n    color: #FBFBFB;\n}\n.final__socialWrapper{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.final__socialLink{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0 0.21875em;\n    padding: 0;\n    border: none;\n    background: transparent;\n}\n.final__socialLink svg{\n    width: 2.3125em;\n    height: auto;\n}\n.final__second{\n    background: #232325;\n    border-radius: 1.5em;\n    padding: 2.35em 0 2.1em;\n    margin-bottom: 1.8em;\n}\n.final__secondTitle{\n    font-weight: 700;\n    font-size: 1.875em;\n    line-height: 1;\n    letter-spacing: 0.01em;\n    margin-bottom: 0.75rem;\n}\n.final__secondText{\n    font-size: 0.875em;\n    line-height: 1.286;\n    margin-bottom: 2.1em;\n}\n.final__secondScroll{\n    overflow: auto;\n    padding-bottom: 0.8em;\n    width: 100vw;\n}\n.final__secondWrapper{\n    display: flex;\n    align-items: flex-start;\n    padding-left: 0.6em;\n}\n.final__people{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    flex-shrink: 0;\n    width: 5.82em;\n}\n.final__people:last-child{\n    padding-right: 0.6em;\n    width: 6.42em;\n}\n.final__peopleAva{\n    width: 3.75em;\n    height: 3.75em;\n    border-radius: 100%;\n    margin-bottom: 0.5em;\n}\n.final__peopleName{\n    color: #FFEAEA;\n    font-size: 0.875em;\n    line-height: 1.286;    \n}\n.final__peopleName svg{\n    display: none;\n    width: 0.75rem;\n    height: auto;\n}\n.final__secondBottomText{\n    display: none;\n}\n.final__third{\n    padding-bottom: 2em;\n}\n.final__thirdIco{\n    display: inline-block;\n    width: 2.5625em;\n    height: auto;\n    margin-bottom: 0.9em;\n}\n.final__thirdText{\n    margin: 0 auto;\n    max-width: 19em;\n    font-size: 0.875em;\n    line-height: 1.286;  \n    margin-bottom: 1.8rem;  \n}\n.final__thirdBtns{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n.btn__final{\n    margin-bottom: 1.1em;\n    width: 9.0625em;\n}\n.btn__restart{\n    width: 9.875em;\n    background: #454545;\n}\n@media(min-width: 100vh){\n    .final{\n        display: flex;\n        align-items: flex-start;\n        justify-content: space-between;\n        width: 100%;\n        position: relative;\n        max-width: 74em;\n        margin: 0 auto;\n        left: 1.85em;\n        padding: 5.7em 0.5em 0;\n    }\n    .final__first{\n        padding: 0;\n        width: 21.125em;\n    }\n    .final__rating{\n        border-radius: 2.8125em;\n        padding: 0 2.125em 1em;\n        min-height: 24.8125em;\n        margin-bottom: 1.1em;\n    }\n    .final__ratingLogo{\n        display: none;\n    }\n    .final__image{\n        height: 12.8125em;\n        margin: -1.2em 0 0.5em;\n    }\n    .final__resultTitle{\n        font-size: 2.1875em;\n        min-height: 4.375rem;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        margin-bottom: 1rem;\n    }\n    .final__resultText{\n        font-size: 0.9375em;\n        line-height: 1.13333;\n    }\n    .final__socialTitle{\n        font-size: 1em;\n        margin-bottom: 1em;\n    }\n    .final__socialLink{\n        transition: 0.3s transform;\n    }\n    .final__socialLink:hover{\n        transform: scale(1.05);\n    }\n    .final__second{\n        width: 22em;\n        border-radius: 0;\n        background: transparent;\n        margin: 0 2.3em 0 0;\n        padding: 2.35em 0 0em;\n    }\n    .final__secondTitle,\n    .final__secondText{\n        display: none;\n    }\n    .final__secondScroll{\n        width: 100%;\n        overflow: inherit;\n    }\n    .final__secondWrapper{\n        padding: 0;\n        flex-wrap: wrap;\n        justify-content: center;\n    }\n    .final__people,\n    .final__people:last-child{\n        padding: 0;\n        width: 7.2em;\n        margin-bottom: 1em;\n        transition: 0.3s transform;\n    }\n    .final__people:hover{\n        transform: scale(1.05);\n    }\n    .final__peopleAva{\n        width: 4.1875em;\n        height: 4.1875em;\n        margin-bottom: 0.7em;\n    }\n    .final__peopleName{\n        font-weight: 500;\n        font-size: 0.75em;\n        color: #fff;\n        max-width: 8em; \n    }\n    .final__peopleName svg{\n        display: inline-block;\n        position: relative;\n        top: 0.1rem;\n    }\n    .final__peopleName span{\n        white-space: nowrap;\n    }\n    .natSpan{\n        display: flex;\n        justify-content: center;\n        align-items: center;\n    }\n    .natSpan svg{\n        top: -0.1em;\n        flex-shrink: 0;\n        margin-left: 0.2em;\n    }\n    .final__secondBottomText{\n        margin: 1em auto 0; \n        line-height: 1.1875;\n        color: #FBFBFB;\n        display: block;\n    }\n    .final__third{\n        width: 21.3125em;\n        text-align: left;\n        padding: 0;\n    }\n    .final__thirdIco{\n        margin: 2.75em 0 1.35em -0.25em;\n    }\n    .final__thirdText{\n        max-width: 100%;\n        font-size: 1.5em;\n        line-height: 1.41666;\n        margin-bottom: 1.65rem;\n    }\n    .final__thirdBtns{\n        width: 100%;\n        flex-direction: row;\n        align-items: center;\n    }\n    .btn__final{\n        width: 6.125em;\n        margin: 0 0.5625em 0 0;\n    }\n    .btn__restart{\n        width: 10.125em;\n    }\n    .btn__restart:hover{\n        background: #FF5317;\n    }\n}\n@media(min-width: 100vh) and (max-width: 150vh){\n    .final{\n        left: 0;\n        font-size: 1.4vw;\n    }\n    .final__second{\n        margin: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
